// Client/src/utils/stateLrs/maPlaces.js
// MassDOT coded-value domains, transcribed verbatim from the Road Inventory
// layer metadata (dCounty / dCity) on 2026-07-26. These ship inside the layer's
// own `?f=json`, so baking them in costs one fewer round trip per lookup and
// keeps zone labels working when the service is unreachable.
//
// County codes are federal FIPS (odd numbers 1-27). City codes are MassDOT's
// own 1-351 municipal index, NOT FIPS — do not cross-reference them.

export const MA_COUNTY_NAMES = {
  "1": 'Barnstable',
  "3": 'Berkshire',
  "5": 'Bristol',
  "7": 'Dukes',
  "9": 'Essex',
  "11": 'Franklin',
  "13": 'Hampden',
  "15": 'Hampshire',
  "17": 'Middlesex',
  "19": 'Nantucket',
  "21": 'Norfolk',
  "23": 'Plymouth',
  "25": 'Suffolk',
  "27": 'Worcester',
};

export const MA_CITY_NAMES = {
  "1": 'Abington',
  "2": 'Acton',
  "3": 'Acushnet',
  "4": 'Adams',
  "5": 'Agawam',
  "6": 'Alford',
  "7": 'Amesbury',
  "8": 'Amherst',
  "9": 'Andover',
  "10": 'Arlington',
  "11": 'Ashburnham',
  "12": 'Ashby',
  "13": 'Ashfield',
  "14": 'Ashland',
  "15": 'Athol',
  "16": 'Attleboro',
  "17": 'Auburn',
  "18": 'Avon',
  "19": 'Ayer',
  "20": 'Barnstable',
  "21": 'Barre',
  "22": 'Becket',
  "23": 'Bedford',
  "24": 'Belchertown',
  "25": 'Bellingham',
  "26": 'Belmont',
  "27": 'Berkley',
  "28": 'Berlin',
  "29": 'Bernardston',
  "30": 'Beverly',
  "31": 'Billerica',
  "32": 'Blackstone',
  "33": 'Blandford',
  "34": 'Bolton',
  "35": 'Boston',
  "36": 'Bourne',
  "37": 'Boxborough',
  "38": 'Boxford',
  "39": 'Boylston',
  "40": 'Braintree',
  "41": 'Brewster',
  "42": 'Bridgewater',
  "43": 'Brimfield',
  "44": 'Brockton',
  "45": 'Brookfield',
  "46": 'Brookline',
  "47": 'Buckland',
  "48": 'Burlington',
  "49": 'Cambridge',
  "50": 'Canton',
  "51": 'Carlisle',
  "52": 'Carver',
  "53": 'Charlemont',
  "54": 'Charlton',
  "55": 'Chatham',
  "56": 'Chelmsford',
  "57": 'Chelsea',
  "58": 'Cheshire',
  "59": 'Chester',
  "60": 'Chesterfield',
  "61": 'Chicopee',
  "62": 'Chilmark',
  "63": 'Clarksburg',
  "64": 'Clinton',
  "65": 'Cohasset',
  "66": 'Colrain',
  "67": 'Concord',
  "68": 'Conway',
  "69": 'Cummington',
  "70": 'Dalton',
  "71": 'Danvers',
  "72": 'Dartmouth',
  "73": 'Dedham',
  "74": 'Deerfield',
  "75": 'Dennis',
  "76": 'Dighton',
  "77": 'Douglas',
  "78": 'Dover',
  "79": 'Dracut',
  "80": 'Dudley',
  "81": 'Dunstable',
  "82": 'Duxbury',
  "83": 'East Bridgewater',
  "84": 'East Brookfield',
  "85": 'East Longmeadow',
  "86": 'Eastham',
  "87": 'Easthampton',
  "88": 'Easton',
  "89": 'Edgartown',
  "90": 'Egremont',
  "91": 'Erving',
  "92": 'Essex',
  "93": 'Everett',
  "94": 'Fairhaven',
  "95": 'Fall River',
  "96": 'Falmouth',
  "97": 'Fitchburg',
  "98": 'Florida',
  "99": 'Foxborough',
  "100": 'Framingham',
  "101": 'Franklin',
  "102": 'Freetown',
  "103": 'Gardner',
  "104": 'Aquinnah',
  "105": 'Georgetown',
  "106": 'Gill',
  "107": 'Gloucester',
  "108": 'Goshen',
  "109": 'Gosnold',
  "110": 'Grafton',
  "111": 'Granby',
  "112": 'Granville',
  "113": 'Great Barrington',
  "114": 'Greenfield',
  "115": 'Groton',
  "116": 'Groveland',
  "117": 'Hadley',
  "118": 'Halifax',
  "119": 'Hamilton',
  "120": 'Hampden',
  "121": 'Hancock',
  "122": 'Hanover',
  "123": 'Hanson',
  "124": 'Hardwick',
  "125": 'Harvard',
  "126": 'Harwich',
  "127": 'Hatfield',
  "128": 'Haverhill',
  "129": 'Hawley',
  "130": 'Heath',
  "131": 'Hingham',
  "132": 'Hinsdale',
  "133": 'Holbrook',
  "134": 'Holden',
  "135": 'Holland',
  "136": 'Holliston',
  "137": 'Holyoke',
  "138": 'Hopedale',
  "139": 'Hopkinton',
  "140": 'Hubbardston',
  "141": 'Hudson',
  "142": 'Hull',
  "143": 'Huntington',
  "144": 'Ipswich',
  "145": 'Kingston',
  "146": 'Lakeville',
  "147": 'Lancaster',
  "148": 'Lanesborough',
  "149": 'Lawrence',
  "150": 'Lee',
  "151": 'Leicester',
  "152": 'Lenox',
  "153": 'Leominster',
  "154": 'Leverett',
  "155": 'Lexington',
  "156": 'Leyden',
  "157": 'Lincoln',
  "158": 'Littleton',
  "159": 'Longmeadow',
  "160": 'Lowell',
  "161": 'Ludlow',
  "162": 'Lunenburg',
  "163": 'Lynn',
  "164": 'Lynnfield',
  "165": 'Malden',
  "166": 'Manchester by the Sea',
  "167": 'Mansfield',
  "168": 'Marblehead',
  "169": 'Marion',
  "170": 'Marlborough',
  "171": 'Marshfield',
  "172": 'Mashpee',
  "173": 'Mattapoisett',
  "174": 'Maynard',
  "175": 'Medfield',
  "176": 'Medford',
  "177": 'Medway',
  "178": 'Melrose',
  "179": 'Mendon',
  "180": 'Merrimac',
  "181": 'Methuen',
  "182": 'Middleborough',
  "183": 'Middlefield',
  "184": 'Middleton',
  "185": 'Milford',
  "186": 'Millbury',
  "187": 'Millis',
  "188": 'Millville',
  "189": 'Milton',
  "190": 'Monroe',
  "191": 'Monson',
  "192": 'Montague',
  "193": 'Monterey',
  "194": 'Montgomery',
  "195": 'Mount Washington',
  "196": 'Nahant',
  "197": 'Nantucket',
  "198": 'Natick',
  "199": 'Needham',
  "200": 'New Ashford',
  "201": 'New Bedford',
  "202": 'New Braintree',
  "203": 'New Marlborough',
  "204": 'New Salem',
  "205": 'Newbury',
  "206": 'Newburyport',
  "207": 'Newton',
  "208": 'Norfolk',
  "209": 'North Adams',
  "210": 'North Andover',
  "211": 'North Attleborough',
  "212": 'North Brookfield',
  "213": 'North Reading',
  "214": 'Northampton',
  "215": 'Northborough',
  "216": 'Northbridge',
  "217": 'Northfield',
  "218": 'Norton',
  "219": 'Norwell',
  "220": 'Norwood',
  "221": 'Oak Bluffs',
  "222": 'Oakham',
  "223": 'Orange',
  "224": 'Orleans',
  "225": 'Otis',
  "226": 'Oxford',
  "227": 'Palmer',
  "228": 'Paxton',
  "229": 'Peabody',
  "230": 'Pelham',
  "231": 'Pembroke',
  "232": 'Pepperell',
  "233": 'Peru',
  "234": 'Petersham',
  "235": 'Phillipston',
  "236": 'Pittsfield',
  "237": 'Plainfield',
  "238": 'Plainville',
  "239": 'Plymouth',
  "240": 'Plympton',
  "241": 'Princeton',
  "242": 'Provincetown',
  "243": 'Quincy',
  "244": 'Randolph',
  "245": 'Raynham',
  "246": 'Reading',
  "247": 'Rehoboth',
  "248": 'Revere',
  "249": 'Richmond',
  "250": 'Rochester',
  "251": 'Rockland',
  "252": 'Rockport',
  "253": 'Rowe',
  "254": 'Rowley',
  "255": 'Royalston',
  "256": 'Russell',
  "257": 'Rutland',
  "258": 'Salem',
  "259": 'Salisbury',
  "260": 'Sandisfield',
  "261": 'Sandwich',
  "262": 'Saugus',
  "263": 'Savoy',
  "264": 'Scituate',
  "265": 'Seekonk',
  "266": 'Sharon',
  "267": 'Sheffield',
  "268": 'Shelburne',
  "269": 'Sherborn',
  "270": 'Shirley',
  "271": 'Shrewsbury',
  "272": 'Shutesbury',
  "273": 'Somerset',
  "274": 'Somerville',
  "275": 'South Hadley',
  "276": 'Southampton',
  "277": 'Southborough',
  "278": 'Southbridge',
  "279": 'Southwick',
  "280": 'Spencer',
  "281": 'Springfield',
  "282": 'Sterling',
  "283": 'Stockbridge',
  "284": 'Stoneham',
  "285": 'Stoughton',
  "286": 'Stow',
  "287": 'Sturbridge',
  "288": 'Sudbury',
  "289": 'Sunderland',
  "290": 'Sutton',
  "291": 'Swampscott',
  "292": 'Swansea',
  "293": 'Taunton',
  "294": 'Templeton',
  "295": 'Tewksbury',
  "296": 'Tisbury',
  "297": 'Tolland',
  "298": 'Topsfield',
  "299": 'Townsend',
  "300": 'Truro',
  "301": 'Tyngsborough',
  "302": 'Tyringham',
  "303": 'Upton',
  "304": 'Uxbridge',
  "305": 'Wakefield',
  "306": 'Wales',
  "307": 'Walpole',
  "308": 'Waltham',
  "309": 'Ware',
  "310": 'Wareham',
  "311": 'Warren',
  "312": 'Warwick',
  "313": 'Washington',
  "314": 'Watertown',
  "315": 'Wayland',
  "316": 'Webster',
  "317": 'Wellesley',
  "318": 'Wellfleet',
  "319": 'Wendell',
  "320": 'Wenham',
  "321": 'West Boylston',
  "322": 'West Bridgewater',
  "323": 'West Brookfield',
  "324": 'West Newbury',
  "325": 'West Springfield',
  "326": 'West Stockbridge',
  "327": 'West Tisbury',
  "328": 'Westborough',
  "329": 'Westfield',
  "330": 'Westford',
  "331": 'Westhampton',
  "332": 'Westminster',
  "333": 'Weston',
  "334": 'Westport',
  "335": 'Westwood',
  "336": 'Weymouth',
  "337": 'Whately',
  "338": 'Whitman',
  "339": 'Wilbraham',
  "340": 'Williamsburg',
  "341": 'Williamstown',
  "342": 'Wilmington',
  "343": 'Winchendon',
  "344": 'Winchester',
  "345": 'Windsor',
  "346": 'Winthrop',
  "347": 'Woburn',
  "348": 'Worcester',
  "349": 'Worthington',
  "350": 'Wrentham',
  "351": 'Yarmouth',
};

// MassDOT Highway Districts 1-6. The Hwy_Dist field carries the number with no
// coded-value domain attached, so this is a label-only formatter — it must not
// invent a district for a value the data doesn't carry.
export function maDistrictLabel(hwyDist) {
  const n = Number(hwyDist);
  return Number.isInteger(n) && n >= 1 && n <= 6 ? `MassDOT District ${n}` : null;
}
